/**
 * Generates a login form with a reset password link
 */
(function () {
  /**
   * Creates and returns a label jQuery element that contains the email input
   * @return {jQuery} A jQuery label element. Inside it will be the email input
   */
  var emailLabelInput = function () {
    return $("<label />", { text: "Email" }).append(
      $("<input />", {
        name: "email",
        type: "email",
      }),
    );
  };

  /**
   * Creates and returns a label jQuery element that contains the password input
   * @return {jQuery} A jQuery label element. Inside it will be the password input
   */
  var passwordLabelInput = function () {
    return $("<label />", { text: "Password" }).append(
      $("<input />", {
        name: "password",
        type: "password",
      }),
    );
  };

  /**
   * Creates the forgot password link and submit button for the login form. When you
   * submit the forgot password it will also fade out the form and fade it back in
   * once the password is sent.
   *
   * @param {jQuery} $form The form element to find the email value and to fade out
   * @return {jQuery}
   */
  var submitWrapper = function ($form) {
    var $forgotPasswordLink = $("<a />", {
      text: "Forgot Password",
      href: "#",
      click: function () {
        // Fade it out to show that it's working
        $form.css("opacity", 0.5);
        BatchGeoSession.forgotPassword(
          $form.find("[name=email]").val(),
          function () {
            // Fade back in to show it's done
            $form.css("opacity", 1);
          },
        );
        return false;
      },
    });

    const $submitButton = $("<input />", {
      name: "submit",
      type: "submit",
      value: "Login",
      class: "button white",
    });

    return $("<div />", {
      class: "batchgeo-ui-login-form-submit-wrapper",
    }).append([$forgotPasswordLink, $submitButton]);
  };

  BatchGeoUi.LoginForm = function () {
    var $emailLabelInput = emailLabelInput();
    var $passwordLabelInput = passwordLabelInput();
    var $form = $("<form />", {
      class: "batchgeo-ui-login-form",
      submit: function () {
        BatchGeoSession.login(
          $emailLabelInput.find("input").val(),
          $passwordLabelInput.find("input").val(),
        );
        return false;
      },
    });

    return $form.append([
      $emailLabelInput,
      $passwordLabelInput,
      submitWrapper($form),
    ]);
  };
})(window);
